import { render, staticRenderFns } from "./ServiceContractListTable.vue?vue&type=template&id=70e4ba2a&scoped=true&lang=pug"
import script from "./ServiceContractListTable.vue?vue&type=script&lang=js"
export * from "./ServiceContractListTable.vue?vue&type=script&lang=js"
import style0 from "./ServiceContractListTable.vue?vue&type=style&index=0&id=70e4ba2a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e4ba2a",
  null
  
)

export default component.exports